module.exports = __webpack_public_path__ + "img/slideshow-premiere-couverture-lmds-bandeau.5b95f47d.png";